import type { SchemaViewerFieldExpressionProps } from "./schema-viewer-field-expression.type";

import { Typography } from "antd";

import { ExpressionErrorAlert } from "@/modules/expression/expression-error-alert";
import { isNil } from "@/utilities/data";

import { SCHEMA_VIEWER_EXPRESSION_FALLBACK_VALUE } from "./schema-viewer-field-expression.constant";
import { useSchemaViewerFieldExpression } from "./schema-viewer-field-expression.hook";

const { Text } = Typography;

export const SchemaViewerFieldExpression = (
  props: SchemaViewerFieldExpressionProps
) => {
  const { value, error } = useSchemaViewerFieldExpression(props);

  if (error) {
    return <ExpressionErrorAlert error={error} />;
  }

  return (
    <Text strong style={{ width: "100%" }}>
      {!isNil(value) ? value : SCHEMA_VIEWER_EXPRESSION_FALLBACK_VALUE}
    </Text>
  );
};
